import { render } from "./ModalCompetitorsInfo.vue?vue&type=template&id=7eaa2444&scoped=true&ts=true"
import script from "./ModalCompetitorsInfo.vue?vue&type=script&lang=ts"
export * from "./ModalCompetitorsInfo.vue?vue&type=script&lang=ts"

import "./ModalCompetitorsInfo.vue?vue&type=style&index=0&id=7eaa2444&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/pontuei/pontuei-painel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eaa2444"]])

export default __exports__